module.exports = __webpack_public_path__ + "static/media/marker_fav.1ebdcae2.png";